import { c as _c } from "react/compiler-runtime";
import { ThumbnailBaseCommonType } from '@systemeio/digital-store-shared';
import { ThankYouPageErrorsType } from 'modules/stores/store/types/store-common-interface';
import { getThankYouErrorChecker, getThumbnailErrorChecker } from 'modules/stores/store/utils/get-error-checkers';
import { useFormErrorMessageInTabs } from 'modules/stores/store/utils/use-form-error-message-in-tabs';
import { OptinTabEnum, optinTabLocoKeys } from '../enum/optin-tab-enum';
export const useErrorMessageInTabs = () => {
  const $ = _c(2);
  const {
    formErrorMessage: formErrorMessageCommon
  } = useFormErrorMessageInTabs();
  const getTabsWithErrors = _temp;
  let t0;
  if ($[0] !== formErrorMessageCommon) {
    const formErrorMessage = t1 => {
      const {
        errors: errors_0
      } = t1;
      const tabsErrorsMap = getTabsWithErrors({
        errors: errors_0
      });
      return formErrorMessageCommon({
        tabsErrorsMap,
        tabsLocoKeys: optinTabLocoKeys
      });
    };
    t0 = {
      getTabsWithErrors,
      formErrorMessage
    };
    $[0] = formErrorMessageCommon;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
function _temp(t0) {
  const {
    errors
  } = t0;
  const hasThumbnailError = getThumbnailErrorChecker(errors);
  const hasThankYouError = getThankYouErrorChecker(errors);
  return {
    [OptinTabEnum.thumbnail]: hasThumbnailError,
    [OptinTabEnum.thankYou]: hasThankYouError,
    [OptinTabEnum.options]: false
  };
}